import { render } from "./Drone.vue?vue&type=template&id=726c2b1e"
import script from "./Drone.vue?vue&type=script&lang=js"
export * from "./Drone.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__